export const IS_FETCHING_LOGIN = "IS_FETCHING_LOGIN";
export const SET_IS_LOGIN_ERROR = "SET_IS_LOGIN_ERROR";
export const SET_LOGIN_ERROR_MESSAGE = "SET_LOGIN_ERROR_MESSAGE";

export const SET_IS_FETCHING_FORGOT_PASSWORD =
  "SET_IS_FETCHING_FORGOT_PASSWORD";
export const SET_IS_FORGOT_PASSWORD_SUCCESS = "SET_IS_FORGOT_PASSWORD_SUCCESS";
export const SET_IS_FORGOT_PASSWORD_ERROR = "SET_IS_FORGOT_PASSWORD_ERROR";
export const RESET_FORGOT_PASSWORD_REQUEST = "RESET_FORGOT_PASSWORD_REQUEST";
export const LOG_OUT = "LOG_OUT";

export const SET_ASSESSMENT_REDIRECT_PATH = "SET_ASSESSMENT_REDIRECT_PATH";
export const RESET_ASSESSMENT_REDIRECT_PATH = "RESET_ASSESSMENT_REDIRECT_PATH";

export const IS_SUBSCRIPTION_INACTIVE = "IS_SUBSCRIPTION_INACTIVE";
export const SET_PARTICIPANT = "SET_PARTICIPANT";
export const SET_PARTICIPANT_TYPE = "SET_PARTICIPANT_TYPE";
export const SET_AUTH_ID = "SET_AUTH_ID";
export const SET_ORGANIZATION_ACCOUNT = "SET_ORGANIZATION_ACCOUNT";
